export default {
  all: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/licensePermitType/state.js